import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import useStore from '../store'

export default function AuthPage() {
  const navigate = useNavigate()
  const signIn   = useStore(s => s.signIn)
  const signUp   = useStore(s => s.signUp)
  const boot     = useStore(s => s.boot)

  const [mode,   setMode]  = useState('signin')
  const [email,  setEmail] = useState('')
  const [pass,   setPass]  = useState('')
  const [busy,   setBusy]  = useState(false)
  const [err,    setErr]   = useState('')

  const submit = async () => {
    if (!email.trim() || !pass.trim()) return setErr('Email and password required.')
    setBusy(true); setErr('')

    const { error } = mode === 'signup'
      ? await signUp(email.trim(), pass)
      : await signIn(email.trim(), pass)

    if (error) { setBusy(false); return setErr(error.message) }

    await boot()
    const profile = useStore.getState().profile
    navigate(profile?.onboarding_completed_at ? '/canvas' : '/onboarding', { replace: true })
  }

  return (
    <div className="min-h-screen bg-m-bg flex items-center justify-center p-6">
      <motion.div
        className="w-full max-w-sm"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        {/* Wordmark */}
        <div className="mb-10">
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-m-accent font-medium">MORI</p>
          <p className="font-mono text-xs text-m-subtle mt-1 tracking-wide">what remains is yours</p>
        </div>

        {/* Mode tabs */}
        <div className="flex border-b border-m-border mb-6">
          {['signin', 'signup'].map(m => (
            <button
              key={m}
              onClick={() => { setMode(m); setErr('') }}
              className={`flex-1 font-mono text-[11px] tracking-widest uppercase py-2 border-b-2 -mb-px transition-colors ${
                mode === m ? 'border-m-accent text-m-text' : 'border-transparent text-m-subtle hover:text-m-text'
              }`}
            >
              {m === 'signin' ? 'Sign in' : 'Create account'}
            </button>
          ))}
        </div>

        <div className="flex flex-col gap-4">
          <div>
            <label className="label block mb-1.5">Email</label>
            <input
              type="email" autoFocus
              className="input"
              placeholder="you@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && submit()}
            />
          </div>

          <div>
            <label className="label block mb-1.5">Password</label>
            <input
              type="password"
              className="input"
              placeholder="••••••••"
              value={pass}
              onChange={e => setPass(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && submit()}
            />
          </div>

          {err && <div className="alert-danger">{err}</div>}

          <button onClick={submit} disabled={busy} className="btn-primary w-full mt-1">
            {busy ? 'Please wait…' : mode === 'signup' ? 'Create account' : 'Sign in'}
          </button>
        </div>

        <p className="font-mono text-[11px] text-m-faint text-center mt-10 leading-relaxed">
          memento mori<br />
          <span className="text-m-subtle">what remains is yours to allocate</span>
        </p>
      </motion.div>
    </div>
  )
}
